'use strict';
import * as $j_app$002eapi$002e$002dApp$002dPage$002dSize from "./app.api.-App-Page-Size.js";
import * as $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241 from "./app.api.-App-Page-Size$$anon$1.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___25;
}
export { $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize };
function $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___50;
}
export { $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize };
function $s_Lapp_api_AppPageSize$___75__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___75;
}
export { $s_Lapp_api_AppPageSize$___75__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___75__Lapp_api_AppPageSize };
function $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___100;
}
export { $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize };
function $s_Lapp_api_AppPageSize$___125__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___125;
}
export { $s_Lapp_api_AppPageSize$___125__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___125__Lapp_api_AppPageSize };
function $s_Lapp_api_AppPageSize$___150__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___150;
}
export { $s_Lapp_api_AppPageSize$___150__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___150__Lapp_api_AppPageSize };
function $s_Lapp_api_AppPageSize$___175__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___175;
}
export { $s_Lapp_api_AppPageSize$___175__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___175__Lapp_api_AppPageSize };
function $s_Lapp_api_AppPageSize$___200__Lapp_api_AppPageSize() {
  $m_Lapp_api_AppPageSize$();
  return $t_Lapp_api_AppPageSize$___200;
}
export { $s_Lapp_api_AppPageSize$___200__Lapp_api_AppPageSize as $s_Lapp_api_AppPageSize$___200__Lapp_api_AppPageSize };
/** @constructor */
function $c_Lapp_api_AppPageSize$() {
  this.aw1 = null;
  this.aw4 = null;
  this.aw5 = false;
  this.aw8 = null;
  this.aw9 = false;
  this.aw6 = null;
  this.aw7 = false;
  this.awa = null;
  this.awb = false;
  this.aw2 = null;
  this.aw3 = false;
  $n_Lapp_api_AppPageSize$ = this;
  $t_Lapp_api_AppPageSize$___25 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_25", 0);
  $t_Lapp_api_AppPageSize$___50 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_50", 1);
  $t_Lapp_api_AppPageSize$___75 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_75", 2);
  $t_Lapp_api_AppPageSize$___100 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_100", 3);
  $t_Lapp_api_AppPageSize$___125 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_125", 4);
  $t_Lapp_api_AppPageSize$___150 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_150", 5);
  $t_Lapp_api_AppPageSize$___175 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_175", 6);
  $t_Lapp_api_AppPageSize$___200 = new $j_app$002eapi$002e$002dApp$002dPage$002dSize$0024$0024anon$00241.$c_Lapp_api_AppPageSize$$anon$1("_200", 7);
  this.aw1 = new ($j_app$002eapi$002e$002dApp$002dPage$002dSize.$d_Lapp_api_AppPageSize.r().C)([$s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize(), $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize(), $s_Lapp_api_AppPageSize$___75__Lapp_api_AppPageSize(), $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize(), $s_Lapp_api_AppPageSize$___125__Lapp_api_AppPageSize(), $s_Lapp_api_AppPageSize$___150__Lapp_api_AppPageSize(), $s_Lapp_api_AppPageSize$___175__Lapp_api_AppPageSize(), $s_Lapp_api_AppPageSize$___200__Lapp_api_AppPageSize()]);
}
export { $c_Lapp_api_AppPageSize$ as $c_Lapp_api_AppPageSize$ };
$p = $c_Lapp_api_AppPageSize$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_AppPageSize$;
/** @constructor */
function $h_Lapp_api_AppPageSize$() {
}
export { $h_Lapp_api_AppPageSize$ as $h_Lapp_api_AppPageSize$ };
$h_Lapp_api_AppPageSize$.prototype = $p;
$p.bZy = (function() {
  return this.aw1.aS();
});
$p.il = (function() {
  if ((!this.aw5)) {
    this.aw4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aw5 = true;
  }
  return this.aw4;
});
$p.brN = (function() {
  if ((!this.aw9)) {
    this.aw8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__circeKeyCodec__Lframework_utils_CirceKeyCodec($m_Lapp_api_AppPageSize$namedEnum$());
    this.aw9 = true;
  }
  return this.aw8;
});
$p.py = (function() {
  if ((!this.aw7)) {
    this.aw6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_CirceCodecExts$package$().W1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Codec$(), this.brN(), this.brN());
    this.aw7 = true;
  }
  return this.aw6;
});
$p.um = (function() {
  if ((!this.awb)) {
    this.awa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__tapirCodec__Lsttp_tapir_Codec($m_Lapp_api_AppPageSize$namedEnum$());
    this.awb = true;
  }
  return this.awa;
});
$p.hL = (function() {
  if ((!this.aw3)) {
    this.aw2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aw3 = true;
  }
  return this.aw2;
});
$p.dl = (function(x) {
  return x.ahn;
});
var $d_Lapp_api_AppPageSize$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_AppPageSize$, "app.api.AppPageSize$", ({
  y4: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_api_AppPageSize$ as $d_Lapp_api_AppPageSize$ };
var $n_Lapp_api_AppPageSize$;
function $m_Lapp_api_AppPageSize$() {
  if ((!$n_Lapp_api_AppPageSize$)) {
    $n_Lapp_api_AppPageSize$ = new $c_Lapp_api_AppPageSize$();
  }
  return $n_Lapp_api_AppPageSize$;
}
export { $m_Lapp_api_AppPageSize$ as $m_Lapp_api_AppPageSize$ };
/** @constructor */
function $c_Lapp_api_AppPageSize$namedEnum$() {
  this.awc = null;
  this.awd = null;
  this.awe = false;
  $n_Lapp_api_AppPageSize$namedEnum$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__$init$__V(this);
}
export { $c_Lapp_api_AppPageSize$namedEnum$ as $c_Lapp_api_AppPageSize$namedEnum$ };
$p = $c_Lapp_api_AppPageSize$namedEnum$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_AppPageSize$namedEnum$;
/** @constructor */
function $h_Lapp_api_AppPageSize$namedEnum$() {
}
export { $h_Lapp_api_AppPageSize$namedEnum$ as $h_Lapp_api_AppPageSize$namedEnum$ };
$h_Lapp_api_AppPageSize$namedEnum$.prototype = $p;
$p.IK = (function() {
  return this.awc;
});
$p.VV = (function(x$0) {
  this.awc = x$0;
});
$p.wy = (function() {
  if ((!this.awe)) {
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().fw($m_Lapp_api_AppPageSize$().bZy());
    this.awd = $x_1.E4($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().aO(this$2));
    this.awe = true;
  }
  return this.awd;
});
$p.bY1 = (function(a) {
  var x = $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize();
  if ((x === a)) {
    return "25";
  }
  var x$3 = $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize();
  if ((x$3 === a)) {
    return "50";
  }
  var x$5 = $s_Lapp_api_AppPageSize$___75__Lapp_api_AppPageSize();
  if ((x$5 === a)) {
    return "75";
  }
  var x$7 = $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize();
  if ((x$7 === a)) {
    return "100";
  }
  var x$9 = $s_Lapp_api_AppPageSize$___125__Lapp_api_AppPageSize();
  if ((x$9 === a)) {
    return "125";
  }
  var x$11 = $s_Lapp_api_AppPageSize$___150__Lapp_api_AppPageSize();
  if ((x$11 === a)) {
    return "150";
  }
  var x$13 = $s_Lapp_api_AppPageSize$___175__Lapp_api_AppPageSize();
  if ((x$13 === a)) {
    return "175";
  }
  var x$15 = $s_Lapp_api_AppPageSize$___200__Lapp_api_AppPageSize();
  if ((x$15 === a)) {
    return "200";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(a);
});
$p.bXR = (function(a) {
  var x = $s_Lapp_api_AppPageSize$___25__Lapp_api_AppPageSize();
  if ((x === a)) {
    return 25;
  }
  var x$3 = $s_Lapp_api_AppPageSize$___50__Lapp_api_AppPageSize();
  if ((x$3 === a)) {
    return 50;
  }
  var x$5 = $s_Lapp_api_AppPageSize$___75__Lapp_api_AppPageSize();
  if ((x$5 === a)) {
    return 75;
  }
  var x$7 = $s_Lapp_api_AppPageSize$___100__Lapp_api_AppPageSize();
  if ((x$7 === a)) {
    return 100;
  }
  var x$9 = $s_Lapp_api_AppPageSize$___125__Lapp_api_AppPageSize();
  if ((x$9 === a)) {
    return 125;
  }
  var x$11 = $s_Lapp_api_AppPageSize$___150__Lapp_api_AppPageSize();
  if ((x$11 === a)) {
    return 150;
  }
  var x$13 = $s_Lapp_api_AppPageSize$___175__Lapp_api_AppPageSize();
  if ((x$13 === a)) {
    return 175;
  }
  var x$15 = $s_Lapp_api_AppPageSize$___200__Lapp_api_AppPageSize();
  if ((x$15 === a)) {
    return 200;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(a);
});
$p.yN = (function(a) {
  return this.bY1(a);
});
var $d_Lapp_api_AppPageSize$namedEnum$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_AppPageSize$namedEnum$, "app.api.AppPageSize$namedEnum$", ({
  y6: 1,
  da: 1,
  Yg: 1
}));
export { $d_Lapp_api_AppPageSize$namedEnum$ as $d_Lapp_api_AppPageSize$namedEnum$ };
var $n_Lapp_api_AppPageSize$namedEnum$;
function $m_Lapp_api_AppPageSize$namedEnum$() {
  if ((!$n_Lapp_api_AppPageSize$namedEnum$)) {
    $n_Lapp_api_AppPageSize$namedEnum$ = new $c_Lapp_api_AppPageSize$namedEnum$();
  }
  return $n_Lapp_api_AppPageSize$namedEnum$;
}
export { $m_Lapp_api_AppPageSize$namedEnum$ as $m_Lapp_api_AppPageSize$namedEnum$ };
var $t_Lapp_api_AppPageSize$___25 = null;
function $u_Lapp_api_AppPageSize$___25(x) {
  $t_Lapp_api_AppPageSize$___25 = x;
}
export { $t_Lapp_api_AppPageSize$___25 as $t_Lapp_api_AppPageSize$___25, $u_Lapp_api_AppPageSize$___25 as $u_Lapp_api_AppPageSize$___25 };
var $t_Lapp_api_AppPageSize$___50 = null;
function $u_Lapp_api_AppPageSize$___50(x) {
  $t_Lapp_api_AppPageSize$___50 = x;
}
export { $t_Lapp_api_AppPageSize$___50 as $t_Lapp_api_AppPageSize$___50, $u_Lapp_api_AppPageSize$___50 as $u_Lapp_api_AppPageSize$___50 };
var $t_Lapp_api_AppPageSize$___75 = null;
function $u_Lapp_api_AppPageSize$___75(x) {
  $t_Lapp_api_AppPageSize$___75 = x;
}
export { $t_Lapp_api_AppPageSize$___75 as $t_Lapp_api_AppPageSize$___75, $u_Lapp_api_AppPageSize$___75 as $u_Lapp_api_AppPageSize$___75 };
var $t_Lapp_api_AppPageSize$___100 = null;
function $u_Lapp_api_AppPageSize$___100(x) {
  $t_Lapp_api_AppPageSize$___100 = x;
}
export { $t_Lapp_api_AppPageSize$___100 as $t_Lapp_api_AppPageSize$___100, $u_Lapp_api_AppPageSize$___100 as $u_Lapp_api_AppPageSize$___100 };
var $t_Lapp_api_AppPageSize$___125 = null;
function $u_Lapp_api_AppPageSize$___125(x) {
  $t_Lapp_api_AppPageSize$___125 = x;
}
export { $t_Lapp_api_AppPageSize$___125 as $t_Lapp_api_AppPageSize$___125, $u_Lapp_api_AppPageSize$___125 as $u_Lapp_api_AppPageSize$___125 };
var $t_Lapp_api_AppPageSize$___150 = null;
function $u_Lapp_api_AppPageSize$___150(x) {
  $t_Lapp_api_AppPageSize$___150 = x;
}
export { $t_Lapp_api_AppPageSize$___150 as $t_Lapp_api_AppPageSize$___150, $u_Lapp_api_AppPageSize$___150 as $u_Lapp_api_AppPageSize$___150 };
var $t_Lapp_api_AppPageSize$___175 = null;
function $u_Lapp_api_AppPageSize$___175(x) {
  $t_Lapp_api_AppPageSize$___175 = x;
}
export { $t_Lapp_api_AppPageSize$___175 as $t_Lapp_api_AppPageSize$___175, $u_Lapp_api_AppPageSize$___175 as $u_Lapp_api_AppPageSize$___175 };
var $t_Lapp_api_AppPageSize$___200 = null;
function $u_Lapp_api_AppPageSize$___200(x) {
  $t_Lapp_api_AppPageSize$___200 = x;
}
export { $t_Lapp_api_AppPageSize$___200 as $t_Lapp_api_AppPageSize$___200, $u_Lapp_api_AppPageSize$___200 as $u_Lapp_api_AppPageSize$___200 };
//# sourceMappingURL=app.api.-App-Page-Size$.js.map
